<template>
    <form-row title="Is this a Cash Purchase?">
        <div class="flex flex-1 items-center">
            <input-radio-boolean
                name="is_cash_purchase"
                v-model="is_cash_purchase"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        is_cash_purchase: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },

}
</script>
